import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import KeyStore from 'utils/KeyStore';

const ProtectedRoute = ({ children, ...rest }) => {
    const isTimeclockDomain = window.location.hostname === new URL(process.env.REACT_APP_TIMECLOCK_HTTP).hostname;

    const pathToCheck = rest?.path || '/';
    const isTimeClockRoute = Array.isArray(pathToCheck)
        ? pathToCheck.some((p) => p.includes('timeclock'))
        : pathToCheck.includes('timeclock');

    return (
        <Route
            {...rest}
            render={
                () => {
                    const keyStore = new KeyStore();

                    if (!keyStore.exists()) {
                        return <Redirect to={{ pathname: '/login' }} />;
                    }

                    if (isTimeclockDomain && !isTimeClockRoute) {
                        return <Redirect to={{ pathname: '/timeclock' }} />;
                    }

                    if (!isTimeclockDomain && isTimeClockRoute) {
                        return <Redirect to={{ pathname: '/' }} />;
                    }

                    return (
                        <>
                            <Helmet
                                defer={false}
                            >
                                <title>{rest?.title || 'Automatrix DMS'}</title>
                                <meta name="description" content={rest?.description || 'Automatrix dmspro App'} />
                            </Helmet>
                            {children}
                        </>
                    );
                }
            }
            onEnter
        />
    );
};

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
